import React from 'react';
import { withRouter } from 'react-router';
import Navbar from '../Navbar/navbar.jsx';
import { isLogin } from '../../utils/authentication.js';
import _ from 'lodash'
import axios from 'axios';
import 'react-bootstrap-typeahead/css/Typeahead.min.css';
import { Link } from "react-router-dom";
import { QuestionListComponent } from "./questionlist";
import {
    BACKEND_URL
} from '../../config.js';
const CMS = () => {
    const [isOptionsLoadin, setisOptionsLoadin] = React.useState(false);
    const [data, setData] = React.useState([]);
    const getAllList = () => {
        axios.get(
            `${BACKEND_URL}/v1/explore/demousers`,
            {
                headers: {
                    token: localStorage.getItem("token")
                }
            }
        ).then((res) => {
            setData(res.data)
            setisOptionsLoadin(false)
        }).catch((err) => {
            setisOptionsLoadin(false)
        })
    }
    React.useEffect(() => {
        setisOptionsLoadin(true)
        getAllList();
    }, [])
    return (
        <div>
            <div className="col-md-12 topbar">
                <Navbar />
            </div>

            <main role="main" className="p-5">
                <div class="d-flex justify-content-center">
                    <h3>Insightmonk - Content management system</h3>
                </div>
                <QuestionListComponent />
            </main>
        </div>
    )
}


export default withRouter(CMS);




// WEBPACK FOOTER //
// ./src/components/Insights/cms.js